import { IPlace } from 'features/Places/types'
import { ISegment } from 'features/Segments/types'
import { TripV2ItineraryStopCheck, TripV2ItineraryStopPlace, TripDriverRsvpNoteStatus } from 'gql/generated/graphql'
import { GTCancellationCategory, GTCancellationSubcategory, GTTripV2 } from 'gql/types.generated'

export interface IChangeDriverForm {
  driver: {
    id: string
    name: string
  }
  category: string
  subcategory?: string
  comments?: string
}

export interface ITimelineFilterValues {
  time: string
  user: {
    id?: string
    username?: string
  }
  event: string
}
export interface ITrip {
  id: string
  segment: ISegment
}

export interface IFare {
  passengerType: string
  subtotal: number
  vat: number
}

export interface IItinerary {
  day: number
  departureTime?: string
  arrivalTime?: string
  place: IPlace
}

export interface ITripSegment {
  id: string
  tripID: string
  availableSeatsNumber: number
  basePrice: number
  itinerary: IItinerary[]
  segment: ISegment
  duration: number
  hasSelectableSeats: boolean
}

export interface INoteFormValues {
  category: string
  paymentIncidents?: boolean
  operationType?: string
  paymentType?: string
  cashAmount?: string
  cardAmount?: string
  message?: string
  realDistance?: string
  files: File[]
  driverRSVPStatus?: TripDriverRsvpNoteStatus | null
}

export interface IChangeVehicleForm {
  vehicle: {
    id: string
    name: string
    externalID?: string | null
  }
  category: string
  subcategory?: string
  comments?: string
}

export interface ISelectedTripsContext {
  selectedTripId?: string
  selectedTrips: GTTripV2[]
  setSelectedTrips: (trips: GTTripV2[]) => void
  setSelectedTripId: (tripId?: string) => void
}

export enum ETripTimelineEventType {
  TripScheduled = 'TripScheduled',
  TripCancelled = 'TripCancelled',
  TripItineraryChanged = 'TripItineraryChanged',
  TripRouteChanged = 'TripRouteChanged',
  TripVehicleChanged = 'TripVehicleChanged',
  TripSaleActivated = 'TripSaleActivated',
  TripSaleDeactivated = 'TripSaleDeactivated',
  TripDriverCheckedIn = 'TripDriverCheckedIn',
  TripDriverStopCheckedIn = 'TripDriverStopCheckedIn',
  TripDriverStopCheckedOut = 'TripDriverStopCheckedOut',
  TripCompleted = 'TripCompleted',
  TripDriverRSVPDeclined = 'TripDriverRSVPDeclined',
  TripDriverRSVPConfirmed = 'TripDriverRSVPConfirmed',
  TripDriverRSVPMissed = 'TripDriverRSVPMissed',
  TripStopCheckedIn = 'TripStopCheckedIn',
  TripStopCheckedOut = 'TripStopCheckedOut'
}

export interface ICancelTripsForm {
  category: GTCancellationCategory | ''
  subcategory?: GTCancellationSubcategory | null | ''
  comments?: string
}

interface IChangeConfirmationModality {
  name: string
  salesChannels: {
    id: string
    name: string
  }[]
  exceptions: {
    places: {
      id: string
      name: string
    }[]
  }
}
export interface IChangeConfirmationModalitiesForm {
  confirmationModalities: IChangeConfirmationModality[]
}

export enum EPunctualityStatus {
  EARLY = 'EARLY',
  ON_TIME = 'ON_TIME',
  MODERATE = 'MODERATE',
  SEVERE = 'SEVERE'
}

export interface ITripStopStatus {
  status: EPunctualityStatus
  arrivalTime?: string
  departureTime?: string
  place: TripV2ItineraryStopPlace
  isOrigin: boolean
  isDestination: boolean
  checkIns: TripV2ItineraryStopCheck[]
}

export interface IDepartureDateFiltersValues {
  departureDateFrom: Date
  departureDateTo: Date
}
